import { Box, Tab, Tabs } from '@mui/material'

import type { Appointment, AppointmentStatus } from '../../types'
import { APPOINTMENT_STATUS_LABELS } from '../../types'

import { AppointmentTable } from './AppointmentTable'
import { APPOINTMENT_STATUSES } from './constants.ts'

import type { OsaEnvironment } from '@/shared/types'

interface AppointmentListProps {
  appointments: Appointment[]
  loading?: boolean
  total?: number
  page?: number
  pageSize?: number
  onPageChange?: (page: number) => void
  onPageSizeChange?: (pageSize: number) => void
  onStatusChange?: (status: AppointmentStatus) => void
  currentStatus?: AppointmentStatus
  sortField?: string
  sortOrder?: 'asc' | 'desc'
  onSortChange?: (field: string, order: 'asc' | 'desc') => void
  envFilter?: OsaEnvironment | undefined
  onEnvFilterChange?: (env: OsaEnvironment | undefined) => void
  typeFilter?: string | undefined
  onTypeFilterChange?: (type: string | undefined) => void
  subtypeFilter?: string[] | undefined
  onSubtypeFilterChange?: (subtypes: string[] | undefined) => void
  funnelFilter?: string | undefined
  onFunnelFilterChange?: (funnel: string | undefined) => void
}

export const AppointmentList = ({
  appointments,
  loading = false,
  total = 0,
  page = 1,
  pageSize = 10,
  onPageChange,
  onPageSizeChange,
  onStatusChange,
  currentStatus = 'new',
  sortField,
  sortOrder,
  onSortChange,
  envFilter,
  onEnvFilterChange,
  typeFilter,
  onTypeFilterChange,
  subtypeFilter,
  onSubtypeFilterChange,
  funnelFilter,
  onFunnelFilterChange,
}: AppointmentListProps) => {
  const handleTabChange = (_: React.SyntheticEvent, newValue: AppointmentStatus) => {
    // Notify parent about status change
    if (onStatusChange) {
      onStatusChange(newValue)
    }
    // Reset to first page when changing tabs
    if (onPageChange) {
      onPageChange(1)
    }
  }

  return (
    <Box>
      <Tabs
        value={currentStatus}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}
      >
        {APPOINTMENT_STATUSES.map(status => (
          <Tab key={status} value={status} label={APPOINTMENT_STATUS_LABELS[status]} />
        ))}
      </Tabs>

      <AppointmentTable
        appointments={appointments}
        loading={loading}
        total={total}
        page={page}
        pageSize={pageSize}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
        currentStatus={currentStatus}
        sortField={sortField}
        sortOrder={sortOrder}
        onSortChange={onSortChange}
        envFilter={envFilter}
        onEnvFilterChange={onEnvFilterChange}
        typeFilter={typeFilter}
        onTypeFilterChange={onTypeFilterChange}
        subtypeFilter={subtypeFilter}
        onSubtypeFilterChange={onSubtypeFilterChange}
        funnelFilter={funnelFilter}
        onFunnelFilterChange={onFunnelFilterChange}
      />
    </Box>
  )
}
